export default __webpack_public_path__ + "static/media/seaweed.7f52b461.jpeg";